// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__MdN7Y","chip__text":"Chip_chip__text__s-GM+","chip__icon":"Chip_chip__icon__5m7E5"};